// frontend/src/constants.ts
const isProduction = import.meta.env.PROD;

export const API_BASE = ''; // Préfixe vide pour les API

export const BACKEND_URL = isProduction
  ? '' // En production, utilise un chemin relatif
  : import.meta.env.VITE_BACKEND_URL || 'http://localhost:3223'; // En dev, URL complète